import { render, staticRenderFns } from "./SearchControlsContainer.vue?vue&type=template&id=8f7b60a0&"
import script from "./SearchControlsContainer.vue?vue&type=script&lang=js&"
export * from "./SearchControlsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports